function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
// DEPRECATED COMPONENT, DO NOT USE. USE APP-COMPONENTS BaseCardHeader INSTEAD.
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
var UUBaseCardHeader = function UUBaseCardHeader(_ref) {
  var children = _ref.children,
    className = _ref.className,
    id = _ref.id,
    title = _ref.title,
    noBorder = _ref.noBorder,
    secondaryFullWidth = _ref.secondaryFullWidth;
  var headerClass = function headerClass() {
    return classNames({
      'bg-white rounded-t': true,
      'border-solid border-b border-medium-border-blue': !noBorder
    }, className);
  };
  var mappedChildren = React.Children.map(children, function (child, index) {
    return /*#__PURE__*/React.createElement("div", {
      className: classNames({
        'flex-grow': secondaryFullWidth
      }, 'relative', 'flex-none', 'ml-3'),
      key: index
    }, child);
  });
  return /*#__PURE__*/React.createElement("div", _extends({}, id ? {
    id: id
  } : {}, {
    className: headerClass()
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-row justify-between"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "flex-auto font-normal p-4 pb-3"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "flex-auto py-1.5 pr-4 pl-0 flex flex-row justify-end items-center"
  }, mappedChildren)));
};
UUBaseCardHeader.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  id: PropTypes.string,
  title: PropTypes.node,
  noBorder: PropTypes.bool,
  secondaryFullWidth: PropTypes.bool
};
UUBaseCardHeader.defaultProps = {
  children: [],
  className: '',
  id: '',
  title: '',
  noBorder: false,
  secondaryFullWidth: false
};
UUBaseCardHeader.displayName = 'UUBaseCardHeader';
export default UUBaseCardHeader;